import { IMAGES } from "@/lib/data";
import { Reveal, MaskedLines } from "./motion";

const imgClass =
  "w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1100ms] ease-out";
const imgProps = { loading: "lazy", decoding: "async" };

export default function Gallery() {
  return (
    <section id="galleria" className="relative bg-charcoal py-24 sm:py-32 grain overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14">
          <div>
            <span className="text-xs tracking-[0.25em] uppercase font-sans font-semibold text-terracotta">
              Galleria
            </span>
            <h2 className="mt-5 font-serif font-light text-5xl sm:text-6xl lg:text-7xl leading-[0.9] text-bone">
              <MaskedLines lines={["Atmosfere"]} />
              <MaskedLines lines={["& sapori"]} lineClassName="italic text-terracotta" delay={0.1} />
            </h2>
          </div>
          <p className="font-sans text-bone/60 max-w-xs text-sm leading-relaxed">
            Il nostro dehors, la sala e i piatti di mare che escono ogni giorno
            dalla cucina.
          </p>
        </div>

        {/* Top block: big dish + 2x2 grid */}
        <div className="grid grid-cols-2 lg:grid-cols-12 gap-4 sm:gap-6">
          <Reveal className="col-span-2 lg:col-span-6 overflow-hidden rounded-sm group">
            <img
              src={IMAGES.dish}
              alt="Trofie al pesto con fagiolini e patate del Bar Gabri"
              {...imgProps} className={`${imgClass} h-[300px] sm:h-[520px]`}
            />
          </Reveal>

          <div className="col-span-2 lg:col-span-6 grid grid-cols-2 gap-4 sm:gap-6">
            <Reveal delay={0.05} className="overflow-hidden rounded-sm group">
              <img src={IMAGES.calamari} alt="Calamari alla griglia con prezzemolo e limone" {...imgProps} className={`${imgClass} h-[150px] sm:h-[248px]`} />
            </Reveal>
            <Reveal delay={0.1} className="overflow-hidden rounded-sm group">
              <img src={IMAGES.cozze} alt="Muscoli alla marinara con crostini di pane" {...imgProps} className={`${imgClass} h-[150px] sm:h-[248px]`} />
            </Reveal>
            <Reveal delay={0.15} className="overflow-hidden rounded-sm group">
              <img src={IMAGES.table} alt="Tavolo sul dehors con linguine ai frutti di mare e vino bianco" {...imgProps} className={`${imgClass} h-[150px] sm:h-[248px]`} />
            </Reveal>
            <Reveal delay={0.2} className="overflow-hidden rounded-sm group">
              <img src={IMAGES.terrace} alt="Dehors del Bar Gabri con tavoli e fiori la sera" {...imgProps} className={`${imgClass} h-[150px] sm:h-[248px]`} />
            </Reveal>
          </div>
        </div>

        {/* Bottom row: interior + sign */}
        <div className="grid grid-cols-2 lg:grid-cols-12 gap-4 sm:gap-6 mt-4 sm:mt-6">
          <Reveal delay={0.05} className="col-span-2 lg:col-span-7 overflow-hidden rounded-sm group">
            <img src={IMAGES.interior} alt="Sala interna del ristorante Gabri" {...imgProps} className={`${imgClass} h-[220px] sm:h-[320px]`} />
          </Reveal>
          <Reveal delay={0.1} className="col-span-2 lg:col-span-5 overflow-hidden rounded-sm group">
            <img src={IMAGES.exterior} alt="Insegna del Bar Gabri Tavola Calda in Via Como 8-10 a Lavagna" {...imgProps} className={`${imgClass} h-[220px] sm:h-[320px]`} />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
